<template>
    <main v-if="!isFetching">
        <v-row class="map_edit_container">
            <v-col cols="12">
                <h5 class="project-title layer-title">
                    <span class="layer_name">
                        <v-select
                            :items="items"
                            v-model="select"
                            item-value="id"
                            item-text="name"
                            solo
                            :menu-props="{ offsetY: true }"
                        ></v-select>
                    </span>
                    <span class="show_info_block">
                        <v-menu
                            v-model="menu"
                            :close-on-content-click="false"
                            offset-y
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                color="grey"
                                dark
                                icon
                                v-bind="attrs"
                                v-on="on"
                                large
                                >
                                <i class="v-icon mdi mdi-cog-outline"></i>
                                </v-btn>
                            </template>

                            <v-list class="settings_switcher_menu">
                                <v-list-item >
                                    <v-switch
                                        v-model="show_info_block"
                                        label="Show Info Block"
                                        color="orange darken-3"
                                        hide-details
                                    ></v-switch>
                                </v-list-item>
                                <v-list-item >
                                    <v-switch
                                        v-model="show_lines"
                                        label="Show Map Lines"
                                        color="orange darken-3"
                                        hide-details
                                    ></v-switch>
                                </v-list-item>
                                <v-list-item >
                                    <v-switch
                                        v-model="show_low_quality_pictures"
                                        label="Low Quality Pictures"
                                        color="orange darken-3"
                                        hide-details
                                    ></v-switch>
                                </v-list-item>
                                <v-list-item hidden>
                                    <v-switch
                                        v-model="show_smooth_pano"
                                        label="Smooth Panoramas"
                                        color="orange darken-3"
                                        hide-details
                                    ></v-switch>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </span>
                </h5>
            </v-col>

            <v-col class="map_container" ref="container">
                <div class="map_block" :style="{'width': block1W}" ref="block1">
                    <div class="map" id="map"></div>
                    <div class="point_info_items" v-if="show_info_block">
                        <span class="point_info_hide" @click="show_info_block = false"><i class="v-icon mdi mdi-close"></i></span>
                        <div class="point_info_item">
                            <span class="point_info_item_label">Name</span>
                            <span class="point_info_item_value">{{pointInfo.name ? pointInfo.name : '-'}}</span>
                        </div>
                        <div class="point_info_item">
                            <span class="point_info_item_label">Size</span>
                            <span class="point_info_item_value">{{pointInfo.size ? formatBytes(pointInfo.size) : '-'}}</span>
                        </div>
                        <div class="point_info_item">
                            <span class="point_info_item_label">Type</span>
                            <span class="point_info_item_value first_capital">{{pointInfo.type ? pointInfo.type : '-'}}</span>
                        </div>
                        <div class="point_info_item">
                            <span class="point_info_item_label">Resolution</span>
                            <span class="point_info_item_value">{{pointInfo.type ? pointInfo.width + 'x' + pointInfo.height : '-'}}</span>
                        </div>
                        <div class="point_info_item">
                            <span class="point_info_item_label">Lat</span>
                            <span class="point_info_item_value">{{pointInfo.latitude ? convertToDMS(pointInfo.latitude, 'lat') : '-'}}</span>
                        </div>
                        <div class="point_info_item">
                            <span class="point_info_item_label">Lng</span>
                            <span class="point_info_item_value">{{pointInfo.longitude ? convertToDMS(pointInfo.longitude, 'lng') : '-'}}</span>
                        </div>
                        <div class="point_info_item">
                            <span class="point_info_item_label">F</span>
                            <span class="point_info_item_value">{{(pointInfo.f_stop && pointInfo.f_stop != -1) ? pointInfo.f_stop : '-'}}</span>
                        </div>
                        <div class="point_info_item">
                            <span class="point_info_item_label">ISO</span>
                            <span class="point_info_item_value">{{(pointInfo.iso && pointInfo.iso != -1) ? pointInfo.iso : '-'}}</span>
                        </div>
                        <div class="point_info_item">
                            <span class="point_info_item_label">Camera</span>
                            <span class="point_info_item_value camera_point_name">{{pointInfo.camera ? pointInfo.camera : '-'}}</span>
                        </div>
                        <div class="point_info_item">
                            <span class="point_info_item_label">Date</span>
                            <span class="point_info_item_value">{{pointInfo.actual_timestamp ? connvertToHumanDate(pointInfo.actual_timestamp) : '-'}}</span>
                        </div>
                    </div>
                </div>
                <div class="slider" @mousedown="drag" @touchstart="startDrag" @touchend="endDrag" :style="{'left': dragW}" ref="drag">
                    <i class="v-icon mdi mdi-arrow-split-vertical"></i>
                </div>
                <div class="project_block_panoram" :style="{'width': block2W}" ref="block2">
                    <div :class="{hidden: !viewer}" class="prev_image_block">
                        <img id="image" src="picture.jpg" alt="Picture">
                    </div>
                    <div id="insert_panorama" :class="{hidden: !pviewer}">
                        <div class="insert_pre_block">
                            <div>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 150">
                                <path
                                    fill="#424242"
                                    d="m0 0v150l4.457-0.91797s68.671-14.113 145.54-14.113c76.872 0 145.54 14.113 145.54 14.113l4.46 0.92v-150l-4.457 0.91602s-68.671 14.113-145.54 14.113c-76.872 0-145.54-14.113-145.54-14.113zm7.4199 9.0098c11.163 2.1752 72 13.439 142.58 13.439s131.42-11.265 142.58-13.439v131.98c-11.16-2.17-72-13.44-142.58-13.44s-131.42 11.267-142.58 13.441zm159.82 63.144c-0.28454-0.51166-0.64312-0.99171-1.0333-1.4485-2.119-2.5791-5.2905-4.2747-8.8638-4.2747-3.585 0-6.7564 1.6856-8.8754 4.253-0.38936 0.4684-0.74877 0.94844-1.0541 1.4701-1.0633 1.7696-1.7072 3.8146-1.7072 6.0318 0 6.4794 5.2081 11.742 11.637 11.742 6.397 0 11.606-5.263 11.606-11.742-0.00083-2.2164-0.63313-4.2613-1.7089-6.0318m6.6083-1.5017c1.0341 2.3021 1.6448 4.8362 1.6448 7.5335 0 10.133-8.1283 18.359-18.15 18.359-10.035 0-18.161-8.2265-18.161-18.359 0-2.6972 0.60151-5.2314 1.644-7.5451h-32.43v27.665c0 3.7497 3.0017 6.8088 6.7356 6.8088h69.682c3.7222 0 6.7564-3.0592 6.7564-6.8088l0.0225-27.653zm-20.41-20.896h-7.1042v-3.4743h7.1042zm6.5126-4.8703h-20.059l-4.1324 6.1166h27.975zm21.819 2.5891h-8.254l-1.4643 3.4843h11.057zm-55.896 1.2047h-6.199l-0.71633 2.2588h7.4303zm31.463 11.147c6.6183 0 12.365 3.6449 15.537 9.0135l18.699 0.02163v-10.135c0-3.7713-3.0342-6.8305-6.7564-6.8305h-69.683c-3.7339 0-6.7356 3.0591-6.7356 6.8305l0.0191 10.049 33.372 0.02246c3.1948-5.3496 8.9179-8.9719 15.548-8.9719"
                                ></path>
                                </svg>
                            </div>
                            <p class="text-center">
                                <strong>Select point to view.</strong>
                            </p>
                        </div>
                    </div>
                    <div class="panorama_info_block"></div>
                </div>
            </v-col>

        </v-row>
    </main>
</template>

<script>
import L            from 'leaflet/dist/leaflet';
import Viewer       from 'viewerjs';
import libpannellum from '../../js/vendors/pannellum/libpannellum';
import panellum     from '../../js/vendors/pannellum/pannellum';

Viewer.setDefaults({
    backdrop:false,
    inline: true,
    navbar: false,
    title: false,
    button: false,
    fullscreen: false
});

export default {
    name: "LayerView",
    data() {
        return {
            isFetching: true,
            menu: false,
            map: null,
            popup: null,
            geoInfo: null,
            panoramas_array: [],
            pano: null,
            id: null,
            select: {},
            block1W: '50%',
            block2W: '50%',
            dragW: 'calc(50% - 20px)',
            viewer: false,
            pviewer: false,
            select_marker: 0,
            no_zoombounds: false,
            show_info_block: true,
            show_lines: true,
            show_low_quality_pictures: false,
            show_smooth_pano: false
        };
    },
    props: ['project_id'],
    computed: {
        current_layer () {
            return this.$store.getters.currentSharedLayer;
        },
        layers () {
            return this.$store.getters.shared_layers;
        },
        pointInfo () {
            return this.$store.getters.pointInfo;
        },
        items () {
            return this.$store.getters.shared_not_empty;
        },
        password () {
            return this.$store.getters.password;
        }
    },
    watch: {
        current_layer () {
            if (!this.isFetching) this.showMap();
        },
        select(val){
            if (typeof val != 'object'){
                this.id = val;
                const layer = {
                    slugid: this.project_id,
                    id: val,
                    show_geo: true,
                    low_quality: (this.show_low_quality_pictures ? 1 : 0),
                    pypreload: (this.show_smooth_pano ? 1 : 0),
                    password: this.password
                };
                this.$store.dispatch('getCurrentSharedLayer', layer);
            }
        },
        show_lines(){
            let line_block = document.querySelector('.leaflet-pane.leaflet-overlay-pane');
            if (line_block != null )document.querySelector('.leaflet-pane.leaflet-overlay-pane').classList.toggle("hide");
            localStorage.show_lines = this.show_lines;
        },
        show_info_block(){
            localStorage.show_info_block = this.show_info_block;
        },
        show_low_quality_pictures(){
            localStorage.show_low_quality_pictures = this.show_low_quality_pictures;
            const layer = {
                slugid: this.project_id,
                id: this.id,
                show_geo: true,
                low_quality: (this.show_low_quality_pictures ? 1 : 0),
                pypreload: (this.show_smooth_pano ? 1 : 0),
                password: this.password
            };
            this.$store.dispatch('getCurrentSharedLayer', layer);
        },
        show_smooth_pano(){
            localStorage.show_smooth_pano = this.show_smooth_pano;
            const layer = {
                slugid: this.project_id,
                id: this.id,
                show_geo: true,
                low_quality: (this.show_low_quality_pictures ? 1 : 0),
                pypreload: (this.show_smooth_pano ? 1 : 0),
                password: this.password
            };
            this.$store.dispatch('getCurrentSharedLayer', layer);
        }
    },
    methods: {
        startDrag(e){
            let dragW = this.$refs.drag;
            let container = this.$refs.container;
            document.ontouchmove = function onTouchMove(e) {
                let dragX = e.changedTouches[0].clientX;
                if (dragX < 300) dragX = 300;
                if (dragX > (container.offsetWidth - 300) ) dragX = container.offsetWidth - 300;
                dragW.style.left = dragX - 20 + "px";
            }
        },
        endDrag(e){
            let block1 = this.$refs.block1;
            let block2 = this.$refs.block2;
            let dragW = this.$refs.drag;
            let container = this.$refs.container;
            document.ontouchstart = document.ontouchmove = null;
            block1.style.width = e.changedTouches[0].clientX - 40  + "px";
            block2.style.width = container.offsetWidth -  e.changedTouches[0].clientX + "px";
            localStorage.block1W = block1.style.width;
            localStorage.block2W = block2.style.width;
            localStorage.dragW = dragW.style.left;
            this.map.invalidateSize()
            this.showMap();
        },
        drag: function(e) {
            let dragXOffcet = e.clientX;
            let block1 = this.$refs.block1;
            let block2 = this.$refs.block2;
            let dragW = this.$refs.drag;
            let container = this.$refs.container;
            document.onmousemove = function onMouseMove(e) {
                let dragX = e.clientX;
                if (dragX < 300) dragX = 300;
                if (dragX > (container.offsetWidth - 300) ) dragX = container.offsetWidth - 300;
                dragW.style.left = dragX - 20 + "px";
                dragXOffcet = dragX;
            }
            document.onmouseup = () => {
                document.onmousemove = document.onmouseup = null;
                block1.style.width = dragXOffcet - 40  + "px";
                block2.style.width = container.offsetWidth -  dragXOffcet + "px";
                localStorage.block1W = block1.style.width;
                localStorage.block2W = block2.style.width;
                localStorage.dragW = dragW.style.left;
                this.map.invalidateSize()
                this.showMap();
            }
        },
        showMap (){
            document.querySelectorAll('.leaflet-marker-icon').forEach(function(node) {
                node.remove();
            });
            document.querySelectorAll('path.leaflet-interactive').forEach(function(node) {
                node.remove();
            });

            document.querySelectorAll('.pnlm-ui.pnlm-grab').forEach(function(node) {
                node.remove();
            });
            document.querySelectorAll('.pnlm-render-container').forEach(function(node) {
                node.remove();
            });

            if (typeof this.current_layer.bounds != 'undefined' && !this.no_zoombounds){
                this.map.fitBounds([ this.current_layer.bounds ]);
                this.no_zoombounds = true;
            }

            const panopopup = document.querySelector('.panorama_info_block');


            document.querySelectorAll('.viewer-container').forEach(function(node) {
              node.remove();
            });
            //let vie = document.querySelector('.viewer-container');
            //if (vie != null) vie.remove();
            let img = document.getElementById('image');
            let viewer = new Viewer(img);

            let data = this.current_layer,
                panoramas_array = [],
                panno = null,
                popup = null,
                i = 0,
                first_element = 0;

            Object.keys(data.geo).map((key, index) => {
                panoramas_array[key] = data.geo[key]['panoramas'];
                L.geoJSON([data.geo[key]['lines'], data.geo[key]['points']], {
                    style: function (feature) {
                        return feature.properties && feature.properties.style;
                    },
                    pointToLayer (feature, latlng) {
                        let myIcon = L.divIcon({
                            className: 'my-div-icon',
                            html: '<span id="marker_' + feature.id + '" class="marker_icon marker_icon_special_'
                              + data.info['id_' + feature.id].special + ' '
                              + (data.info['id_' + feature.id].label != '' ? 'marker_icon_label' : '')
                              + '"></span>'
                        });
                        if (i == 0) first_element = feature.id;
                        i = 1;
                        return L.marker(latlng, { icon: myIcon, zIndexOffset: 100 })
                                .on( 'click', (e) => {

                                    if (panno !== null){
                                        document.querySelectorAll('.pnlm-ui.pnlm-grab').forEach(function(node) {
                                            node.remove();
                                        });
                                        document.querySelectorAll('.pnlm-render-container').forEach(function(node) {
                                            node.remove();
                                        });
                                    }

                                    let id = e.target.feature.id;

                                    center_map(latlng, id);

                                    show_pano_info(data.info['id_' + id].label);

                                    change_info(data.info['id_' + id]);
                                    change_arrow(id, data.info['id_' + id].direction);
                                    change_view_var(false);

                                    if (data.info['id_' + id].type == 'panorama'){
                                        let options = {
                                            "autoLoad": true,
                                            "compass": true,
                                            "default": {
                                                "firstScene": "id_" + id,
                                                "sceneFadeDuration": 1000
                                            },
                                            "scenes": panoramas_array[data.info['id_' + id].layer_id]
                                        };

                                        panno = pannellum.viewer('insert_panorama', options);
                                        panno.on('scenechange', () => {
                                            let id = panno.getScene().substr(3);
                                            if(data.info['id_' + id].type == 'image'){
                                                show_image(data.info['id_' + id].src);
                                            }
                                            else{
                                                change_view_var(false);
                                            }
                                            change_arrow(id, data.info['id_' + id].direction);
                                            show_pano_info(data.info['id_' + id].label);
                                        });
                                    }
                                    else{
                                        show_image(data.info['id_' + id].src);
                                    }
                                })
                                .on('mouseover', (e) =>{
                                    popup_open(e);
                                })
                                .on('mouseout', (e) =>{
                                    popup_close(e);
                                });

                    }
                }).addTo(this.map);
            });

            let center_map = (latlng, id) => {
                this.map.flyTo(latlng);
                this.select_marker = id;
            }

            setTimeout(() => {
                if (this.select_marker == 0)  {
                  document.querySelector('#marker_' + first_element).click();
                }
                else  {
                  document.querySelector('#marker_' + this.select_marker).click();
                }
                if (!this.show_lines)  {
                  document.querySelector('.leaflet-pane.leaflet-overlay-pane').classList.add("hide");
                }
            }, 0);

            let change_arrow = (id, offcet) => {
                let i;
                let elems = document.querySelectorAll('.marker_icon');
                for (i = 0; i < elems.length; ++i) {
                    elems[i].innerHTML = "";
                    elems[i].closest('.leaflet-marker-icon').classList.remove('marker_zindex');
                }
                let element = document.getElementById('marker_' + id);
                element.closest('.leaflet-marker-icon').classList.add('marker_zindex');
                element.innerHTML = '<i id="rotate_arrow" style="transform: rotate(' + offcet + 'deg)" class="material-icons left">navigation</i>';
                console.log(offcet);
            }

            let change_info = (array) => {
                this.$store.dispatch('setPointInfo', array);
            };

            let change_view_var = (newvar) => {
                this.pviewer = !newvar;
                this.viewer = newvar;
            };

            let show_image = (src) => {
                this.viewer = true;
                this.pviewer = false;
                if (viewer != null) viewer.destroy();
                document.querySelectorAll('.viewer-container').forEach(function(node) {
                  node.remove();
                });

                let img = document.getElementById('image');
                img.src = src;
                viewer = new Viewer(img);
            };

            let popup_open = (e) => {
                let id = e.target.feature.id;
                popup = L.popup()
                .setLatLng( e.latlng )
                .setContent( '<b>' + data.info['id_' + id].name + '</b>' + (data.info['id_' + id].label != '' ? '<br>' + data.info['id_' + id].label  : '')  )
                .openOn( this.map );
            };

            let popup_close = (e) => {
                this.map.closePopup( popup );
                popup = null;
            };

            let show_pano_info = (text) => {
                panopopup.classList.remove('active');
                if (text != ''){
                    setTimeout(() => {
                        panopopup.innerHTML = text;
                        panopopup.classList.add('active');
                    }, 200);
                }
            };

        }
    },
    created() {

        if (localStorage.show_info_block)           this.show_info_block = (localStorage.show_info_block == 'true' ? true : false);
        if (localStorage.show_lines)                this.show_lines = (localStorage.show_lines == 'true' ? true : false);
        if (localStorage.show_low_quality_pictures) this.show_low_quality_pictures = (localStorage.show_low_quality_pictures == 'true' ? true : false);
        if (localStorage.show_smooth_pano)          this.show_smooth_pano = (localStorage.show_smooth_pano == 'true' ? true : false);


        if (localStorage.block1W){
            this.block1W = localStorage.block1W;
            this.block2W = localStorage.block2W;
            this.dragW = localStorage.dragW;
        }

        const layer = {
            slugid: this.project_id,
            id: this.layers[this.items[0].layer].id,
            show_geo: true,
            password: this.password,
            low_quality: (this.show_low_quality_pictures ? 1 : 0),
            pypreload: (this.show_smooth_pano ? 1 : 0)
        };
        this.$store.dispatch('getCurrentSharedLayer', layer)
        .then(( response ) => {
            this.isFetching = false;
            setTimeout(() => {
                this.map = L.map('map').setView(this.current_layer.center, 12);
                L.tileLayer('https://tile.teofly.com/tile/m9/{z}/{x}/{y}', {
                    maxZoom: 20,
                    tileSize: 512,
                    zoomOffset: -1
                }).addTo(this.map);

                this.showMap();
            }, 100);
        })
        .catch(() => {});
        this.id = this.layers[this.items[0].layer].id;
        this.select = {name: this.layers[this.items[0].layer].name, id: this.layers[this.items[0].layer].id};
    }
};
</script>
